'use client'

import { CacheLocation, FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react'
import { FINGERPRINT_CACHE_TIME } from '@/utils/constants'

export const FingerprintProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <FpjsProvider
      loadOptions={{
        endpoint: [
          `${process.env.NEXT_PUBLIC_FINGERPRINT_PROXY_HOST}/${process.env.NEXT_PUBLIC_FINGERPRINT_RESULT_PATH}?region=eu`,
        ],
        scriptUrlPattern: [
          `${process.env.NEXT_PUBLIC_FINGERPRINT_PROXY_HOST}/${process.env.NEXT_PUBLIC_FINGERPRINT_AGENT_DOWNLOAD_PATH}/?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>`,
        ],
        apiKey: process.env.NEXT_PUBLIC_FINGERPRINT_API_KEY ?? '',
        region: 'eu',
      }}
      cacheLocation={CacheLocation.LocalStorage}
      cacheTimeInSeconds={FINGERPRINT_CACHE_TIME}
    >
      {children}
    </FpjsProvider>
  )
}
